var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._v(" 페이지네이션 레이지로드 레이아웃 ")])
}
var staticRenderFns = []

export { render, staticRenderFns }